export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};

export const preparePrintWindow = (win, message) => {
  if (!win) return;
  try {
    win.document.title = message;
    const p = win.document.createElement("p");
    p.style.cssText = "font-family:sans-serif;color:#333;padding:24px";
    p.textContent = message;
    win.document.body.appendChild(p);
  } catch (e) {
    console.warn("Não foi possível preparar a janela de impressão:", e);
  }
};

export const openPdfForPrint = (win, url, title) => {
  if (!win) {
    window.open(url, "_blank");
    return;
  }
  win.document.title = title;
  win.document.body.replaceChildren();
  win.document.body.style.margin = "0";
  const frame = win.document.createElement("iframe");
  frame.src = url;
  frame.style.cssText = "border:0;width:100vw;height:100vh";
  frame.onload = () => setTimeout(() => { try { frame.contentWindow.print(); } catch (e) { console.warn("Auto-print indisponível:", e); } }, 500);
  win.document.body.appendChild(frame);
};

export const printBlobInPage = (blob, fallbackFilename) => {
  const url = URL.createObjectURL(blob);
  const frame = document.createElement("iframe");
  frame.setAttribute("data-testid", "inpage-print-frame");
  frame.style.cssText = "position:fixed;right:0;bottom:0;width:1px;height:1px;border:0;visibility:hidden";
  frame.src = url;
  frame.onload = () => setTimeout(() => {
    try {
      frame.contentWindow.focus();
      frame.contentWindow.print();
    } catch (e) {
      console.warn("Impressão na página indisponível, baixando o PDF:", e);
      downloadBlob(blob, fallbackFilename);
    }
  }, 400);
  document.body.appendChild(frame);
  setTimeout(() => { frame.remove(); URL.revokeObjectURL(url); }, 180000);
};

export const blobError = async (err, fallback) => {
  try {
    const d = err?.response?.data;
    if (d instanceof Blob) {
      const j = JSON.parse(await d.text());
      return j.detail || fallback;
    }
    return d?.detail || fallback;
  } catch (e) {
    console.warn("Falha ao interpretar o erro da resposta:", e);
    return fallback;
  }
};
